<script setup>
    defineProps({
        fields: Object,
    })
</script>

<template>
    <div class="section-text container mx-auto mb-10 mt-5" v-html="fields.text" />
</template>

<style>
    .section-text {
        > * {
            @apply my-4;
        }

        h3 {
            @apply mb-2 text-xl font-bold;
            margin-top: 3.5rem;

            &:first-child {
                margin-top: 0;
            }

            & + p {
                @apply mt-2;
            }
        }

        ul, ol {
            padding-left: 2em;

            li {
                @apply my-2;
            }
        }

        ul {
            list-style: disc;
        }

        ol {
            list-style: decimal;
        }

        strong {
            @apply font-bold;
        }

        @media(max-width: 768px) {
            ul, ol {
                padding-left: 1em;
            }
        }

        table {
            @apply my-10 mx-auto;

            td {
                padding-inline:var(--padding);
                padding-block:calc(var(--padding) / 2);
                vertical-align: top;
            }
        }
    }
</style>
